module.exports = __webpack_public_path__ + "img/lowcode-banner.5c150ab1.svg";